/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Status_Importing_MediaInputs */

const en_iconik_proxy_status_importing_media = /** @type {(inputs: Iconik_Proxy_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing media from URL...`)
};

const fr_iconik_proxy_status_importing_media = /** @type {(inputs: Iconik_Proxy_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des medias depuis l'URL...`)
};

const de_iconik_proxy_status_importing_media = /** @type {(inputs: Iconik_Proxy_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien werden von URL importiert...`)
};

const it_iconik_proxy_status_importing_media = /** @type {(inputs: Iconik_Proxy_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione di contenuti multimediali dall'URL...`)
};

const ru_iconik_proxy_status_importing_media = /** @type {(inputs: Iconik_Proxy_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт медиафайлов по URL...`)
};

const es_iconik_proxy_status_importing_media = /** @type {(inputs: Iconik_Proxy_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando medios desde URL...`)
};

const zh_cn2_iconik_proxy_status_importing_media = /** @type {(inputs: Iconik_Proxy_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 URL 导入媒体...`)
};

const ja_iconik_proxy_status_importing_media = /** @type {(inputs: Iconik_Proxy_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL からメディアをインポートしています...`)
};

const hi_iconik_proxy_status_importing_media = /** @type {(inputs: Iconik_Proxy_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यूआरएल से मीडिया आयात किया जा रहा है...`)
};

const pt_pt2_iconik_proxy_status_importing_media = /** @type {(inputs: Iconik_Proxy_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando mídia de URL...`)
};

/**
* | output |
* | --- |
* | "Importing media from URL..." |
*
* @param {Iconik_Proxy_Status_Importing_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_status_importing_media = /** @type {((inputs?: Iconik_Proxy_Status_Importing_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Status_Importing_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_proxy_status_importing_media(inputs)
	if (locale === "de") return de_iconik_proxy_status_importing_media(inputs)
	if (locale === "it") return it_iconik_proxy_status_importing_media(inputs)
	if (locale === "ru") return ru_iconik_proxy_status_importing_media(inputs)
	if (locale === "es") return es_iconik_proxy_status_importing_media(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_proxy_status_importing_media(inputs)
	if (locale === "ja") return ja_iconik_proxy_status_importing_media(inputs)
	if (locale === "hi") return hi_iconik_proxy_status_importing_media(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_proxy_status_importing_media(inputs)
	return en_iconik_proxy_status_importing_media(inputs)
});